export const MODAL_TYPE_MOVE_POST_CONFIRMATION = 'move-post-confirmation';
